import { t } from "@/i18n-js/instance";
import type { useRecommendationsInfiniteQuery } from "@/react/hooks/recommendations/useRecommendationsInfiniteQuery";
import type { Person } from "@/react/types/AudienceList";

import type { ExpandableAccordionItem } from "../../shared/ExpandableAccordion";
import { ExpandableAccordion } from "../../shared/ExpandableAccordion";

interface RecommendationsProps {
  recommendationsQuery: ReturnType<typeof useRecommendationsInfiniteQuery>;
}

export const Recommendations = ({
  recommendationsQuery,
}: RecommendationsProps) => {
  // Keep the panel hidden while the (possibly slow) recommendations request is
  // in flight, rather than rendering a loading skeleton. The empty-result case
  // is still handled by ExpandableAccordion, which renders nothing when there
  // are no items.
  if (recommendationsQuery.isLoading) {
    return null;
  }

  const recommendations = recommendationsQuery.recommendations || [];
  const hasMore = Boolean(recommendationsQuery.hasNextPage);

  const items: ExpandableAccordionItem[] = recommendations.map(item => ({
    id: `${item.id}`,
    person: item.target as Person,
    type: "recommendation",
  }));

  return (
    <ExpandableAccordion
      title={t("members_directory.recommendations.title")}
      items={items}
      totalCount={recommendationsQuery.count ?? 0}
      isLoading={Boolean(recommendationsQuery.isLoading)}
      hasMore={hasMore}
      fetchNextPage={recommendationsQuery.fetchNextPage}
      isFetchingNextPage={Boolean(recommendationsQuery.isFetchingNextPage)}
      className="mb-10"
    />
  );
};
